import { SVGProps, Ref, forwardRef } from 'react';

export const PrinterOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.3 2.8h11.4v3.204c-3.798-.05-7.602-.05-11.4 0zm13.2 3.28C23.377 6.4 24 7.83 24 13s-.623 6.6-4.5 6.92V23h-15v-3.08C.623 19.6 0 18.17 0 13s.623-6.6 4.5-6.92V1h15zm-15 12.033V14h15v4.113q.473-.044.845-.114c.749-.141 1.04-.335 1.18-.475s.333-.43.474-1.18c.144-.767.201-1.827.201-3.344s-.057-2.577-.201-3.344c-.141-.75-.335-1.04-.475-1.18s-.43-.333-1.18-.475C19.578 7.857 18.518 7.8 17 7.8H7c-1.517 0-2.577.057-3.344.201-.75.142-1.04.335-1.18.475s-.333.43-.475 1.18C1.857 10.423 1.8 11.482 1.8 13s.057 2.577.201 3.345c.142.749.335 1.04.475 1.18s.43.333 1.18.474a9 9 0 0 0 .844.114M6.3 15.8h11.4v5.4H6.3z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PrinterOutlinedSize24Glyph.displayName = 'PrinterOutlinedSize24Glyph';
